export default {
  mainView: {
    width: '100%'
  }
};
